import React from "react";

const NavBar = () => {
	return (
		<div className="navbar-container">
			<div className="navbar-container_link-section">
				<div className="navigation-wrapper">
					<a href="#home">Home</a>
					<a href="#work">Work</a>
					<a href="#contact">Contact</a>
				</div>
			</div>
		</div>
	);
};
export default NavBar;